'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('mail-list', {
      url: '/mail/:type/list',
      params:{type:null},
      template: '<mail-list></mail-list>',
      authenticate: 'admin'
    });
}



// WEBPACK FOOTER //
// ./client/app/messaging/mail/list/mail-list.routes.js